export default __webpack_public_path__ + "static/media/Group316.f2e71c15.png";